import $http from '@/libs/axios'

export default class SubscriptionApi {
  static async packagesList() {
    return (await $http.get('admin/packages')).data
  }

  static async updateInvoice(id: number, data: any) {
    return (await $http.post(`admin/invoices/update-status/${id}`, data)).data
  }
}
